import { render, staticRenderFns } from "./CatalogArmisValidation.vue?vue&type=template&id=f15418a0&"
import script from "./CatalogArmisValidation.vue?vue&type=script&lang=ts&"
export * from "./CatalogArmisValidation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports